
import { toast } from "react-toastify";
import axios from "axios";

async function sendEmail({ email, password, mobile, full_name, salon_name }) {

  try {
    const payload = {
      email,
      full_name,
      salon_name,
      mobile,
      password,
    };

    const res = await axios.post(
      "https://node-server-eta-coral.vercel.app/send-email",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_NODE_API_KEY // required by server
        },
      }
    );

    if (res?.data?.success) {
      toast.success("تم إرسال البريد الإلكتروني بنجاح!");
    } else {
      const msg = res?.data?.message || res?.data?.error || 'Unknown error';
      toast.error(`فشل إرسال البريد الإلكتروني: ${msg}`);
    }

    return res.data;
  } catch (err) {
    console.error("Email error:", err);
    toast.error(`تعذر إرسال البريد الإلكتروني. حاول لاحقاً.`);
    return { success: false, error: err.message };
  }
}

export default sendEmail;
